import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Onboarding from "@/pages/Onboarding";
import Workspace from "@/pages/Workspace";
import Blog from "@/pages/Blog";
import Calendar from "@/pages/Calendar";
import History from "@/pages/History";
import TraceViewer from "@/pages/TraceViewer";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Features from "@/pages/Features";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import UseCaseLinkedIn from "@/pages/UseCaseLinkedIn";
import UseCasePersonalBrand from "@/pages/UseCasePersonalBrand";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost1 from "@/pages/BlogPost1";
import BlogPost2 from "@/pages/BlogPost2";
import BlogPost3 from "@/pages/BlogPost3";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/features" element={<Features />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/use-cases/linkedin" element={<UseCaseLinkedIn />} />
                        <Route path="/use-cases/personal-branding" element={<UseCasePersonalBrand />} />
                        <Route path="/blog" element={<BlogIndex />} />
                        <Route path="/blog/linkedin-posts-10x-engagement" element={<BlogPost1 />} />
                        <Route path="/blog/indian-professionals-linkedin-personal-branding" element={<BlogPost2 />} />
                        <Route path="/blog/chatgpt-vs-lakshmi-linkedin-posts" element={<BlogPost3 />} />
                        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
                        <Route path="/workspace" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
                        <Route path="/blog" element={<ProtectedRoute><Blog /></ProtectedRoute>} />
                        <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
                        <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
                        <Route path="/history/:id" element={<ProtectedRoute><TraceViewer /></ProtectedRoute>} />
                        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster theme="dark" position="top-right" />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
